/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Consent_PaymentInputs */

const en_cookie_consent_payment = /** @type {(inputs: Cookie_Consent_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment`)
};

const de_cookie_consent_payment = /** @type {(inputs: Cookie_Consent_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlung`)
};

const fr_cookie_consent_payment = /** @type {(inputs: Cookie_Consent_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiement`)
};

const es_cookie_consent_payment = /** @type {(inputs: Cookie_Consent_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pago`)
};

const it_cookie_consent_payment = /** @type {(inputs: Cookie_Consent_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamento`)
};

const nl_cookie_consent_payment = /** @type {(inputs: Cookie_Consent_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betaling`)
};

const pl_cookie_consent_payment = /** @type {(inputs: Cookie_Consent_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platnosc`)
};

const fi_cookie_consent_payment = /** @type {(inputs: Cookie_Consent_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maksu`)
};

const da_cookie_consent_payment = /** @type {(inputs: Cookie_Consent_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betaling`)
};

const sv_cookie_consent_payment = /** @type {(inputs: Cookie_Consent_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betalning`)
};

/**
* | output |
* | --- |
* | "Payment" |
*
* @param {Cookie_Consent_PaymentInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cookie_consent_payment = /** @type {((inputs?: Cookie_Consent_PaymentInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Consent_PaymentInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cookie_consent_payment(inputs)
	if (locale === "fr") return fr_cookie_consent_payment(inputs)
	if (locale === "es") return es_cookie_consent_payment(inputs)
	if (locale === "it") return it_cookie_consent_payment(inputs)
	if (locale === "nl") return nl_cookie_consent_payment(inputs)
	if (locale === "pl") return pl_cookie_consent_payment(inputs)
	if (locale === "fi") return fi_cookie_consent_payment(inputs)
	if (locale === "da") return da_cookie_consent_payment(inputs)
	if (locale === "sv") return sv_cookie_consent_payment(inputs)
	return en_cookie_consent_payment(inputs)
});